// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HZZi","newExpiryDate":"styles_newExpiryDate__3BAY-","footer":"styles_footer__nsDdJ"};